import client from 'data/client';
import { WorkingHoursData } from 'data/types/workingHours';
import { CDError } from 'utils/error';

export type Variables = {
  brandId: string;
  hoursSettings: WorkingHoursData['hoursSettings'];
  applyToAll: boolean;
};

export type ResponseStatus = {
  status: string;
};

export const updateWorkingHours = async ({
  brandId,
  hoursSettings,
  applyToAll,
}: Variables) => {
  try {
    const { data } = await client.post<ResponseStatus>(
      `/settings/timings/${brandId}`,
      { hoursSettings, applyToAll },
      { headers: { 'content-type': 'application/json' } },
    );
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};
